import XLSX from 'xlsx-js-style';

export const exportTableToExcel = (columns, data, fileTitle = 'RBAC_Manhattan-project') => {
    const columnsWithPreDefinedWidths = {};
    const columnInfo = columns.reduce(
        (acc, column, index) => {
            if (column.exportWidthInPx !== undefined) {
                const cellLetter = String.fromCharCode(index + 65)
                const widthInXLSXUnits = Math.round(column.exportWidthInPx / 10)
                Object.assign(columnsWithPreDefinedWidths, {
                    [cellLetter]: widthInXLSXUnits
                })
            }
            const headerLabel = column.title || column.field;
            acc.header.push(headerLabel);
            acc.map[column.field] = headerLabel;

            return acc;
        }, {
            map: {},
            header: []
        }
    );

    const mappedData = data.map(row =>
        Object.entries(row).reduce((acc, [key, value]) => {
            let columnTitle = columnInfo.map[key];

            if (columnTitle) {
                let valueType = typeof (value);
                if (valueType === 'boolean') {
                    acc[columnTitle] = columnTitle.toLocaleLowerCase().includes('status') ?
                        value === true ? "Active" : "Inactive" :
                        value === true ? "Yes" : "No";
                } else if (valueType === 'object') {
                    acc[columnTitle] = Array.isArray(value) ? value.map(x => {
                        return x.name ? x.name : x.content
                    }).join(",") : null;
                } else if (valueType === 'number') {
                    acc[columnTitle] = columnTitle === 'Quarter' ? quarterMap[value] : value;
                } else {
                    acc[columnTitle] = value;
                }
            }

            return acc;
        }, {})
    );

    var ws = XLSX.utils.json_to_sheet(mappedData, {
        header: columnInfo.header,
    });

    const columnsWidths = getColumnsWidths(ws, columnsWithPreDefinedWidths);
    ws = beautify(ws, columnsWidths);

    var wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    XLSX.writeFile(wb, `${fileTitle}.xlsx`);
};

function beautify(ws, columnsWidths) {
    ws['!cols'] = columnsWidths;
    for (const cell in ws) {
        let isFirstCell = cell.match(/\d+/) && cell.match(/\d+/)[0] === '1'
        if (isFirstCell) {
            ws[cell].s = {
                font: {
                    bold: true,
                },
                alignment: {
                    horizontal: 'center'
                }
            };
        }
    }

    return ws
}

function getColumnsWidths(ws, columnsWithPreDefinedWidths) {
    let widths = Object.entries(ws).reduce((acc, [key, value]) => {
        let currCell = acc[key[0]];
        let currCellLength = value.v && value.v.length;
        if (currCell === undefined && key[0] !== '!') {
            Object.assign(acc, {
                [key[0]]: currCellLength
            });
        } else {
            if (value.v !== undefined) {
                acc[key[0]] = currCell < currCellLength ? currCellLength : currCell
            }
        }
        return acc
    }, {})

    Object.assign(widths, columnsWithPreDefinedWidths)

    let columnWidths = Object.entries(widths)
        .sort((a, b) => a[0].localeCompare(b[0]))
        .reduce((acc, el) => {
            acc.push({
                //add a bit extra space
                width: el[1] + 1
            });
            return acc;
        }, []);

    return columnWidths;
}

const quarterMap = {
    0: 'Q1',
    1: 'Q2',
    2: 'Q3',
    3: 'Q4',
}